export const convertServerTimeToLocal = (time: string | Date) => {
  const svTime = new Date(time);
  const offSet = svTime.getTimezoneOffset() * 60 * 1000;

  return new Date(svTime.getTime() - offSet);
};

export const convertLocalTimeToServer = (
  time: string | Date,
  offSetTime: string | Date
) => {
  const localTime = new Date(time);
  const svTime = new Date(offSetTime);

  const offSet = svTime.getTimezoneOffset() * 60 * 1000;

  return new Date(localTime.getTime() - offSet);
};

export const getFriendlyTimeAgo = (time: string | Date) => {
  const localTime = convertServerTimeToLocal(time);
  const now = Date.now();

  const delta = Number(now - localTime.getTime());

  const TIME_UNIT_ARRAY = ["week", "day", "hour", "minute", "second"];

  const TIME_UNIT_MAP = {
    second: delta / 1000,
    minute: delta / 1000 / 60,
    hour: delta / 1000 / 60 / 60,
    day: delta / 1000 / 60 / 60 / 24,
    week: delta / 1000 / 60 / 60 / 24 / 7
  };

  for (const unit of TIME_UNIT_ARRAY) {
    const value = Math.floor(TIME_UNIT_MAP[unit]);

    if (value > 0) {
      return `${value} ${unit + (value > 1 ? "s" : "")} ago`;
    }
  }

  return "Just now";
};
